export const EXTERNAL_API = 'https://cloud.solar-manager.ch';
